"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomePage = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const antd_1 = require("antd");
const PageContent_1 = __importDefault(require("src/hello_assets/src/components/ui/common/content/PageContent"));
const ProjectsProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/ProjectsProvider");
const PageLoaderComponent_1 = __importDefault(require("src/hello_assets/src/components/ui/common/common/pageLoader/PageLoaderComponent"));
const react_router_dom_1 = require("react-router-dom");
const lodash_1 = __importDefault(require("lodash"));
const isMounted_1 = __importDefault(require("src/hello_assets/src/components/system/isMounted"));
const AppRouting_1 = require("src/hello_assets/src/components/system/AppRouting");
const ProjectModalComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/ProjectModalComponent");
const ProjectsErrorPage_1 = require("src/hello_assets/src/components/ui/loggedin/content/projects/ProjectsErrorPage");
const HomePage = () => {
    const { projectsState: { loaded, data, isError, error }, fetchAllProjects } = (0, ProjectsProvider_1.useProjectsContext)();
    const isMounted = (0, isMounted_1.default)();
    const [createProjectModalVisible, setCreateProjectModalVisible] = (0, react_1.useReducer)((state, newState) => ({ ...state, ...newState }), { visible: false, nonce: 0 });
    const onCreateProjectModalDestroy = (0, react_1.useCallback)(() => {
        if (isMounted()) {
            setCreateProjectModalVisible({ visible: false });
        }
    }, [fetchAllProjects, isMounted]);
    if (loaded) {
        if (!lodash_1.default.isEmpty(data)) {
            return React.createElement(react_router_dom_1.Redirect, { to: AppRouting_1.AppPathGenerator.projects() });
        }
        if (isError) {
            return React.createElement(ProjectsErrorPage_1.ProjectsErrorPage, { error: error });
        }
        const onClickCreateProject = () => {
            setCreateProjectModalVisible({ visible: true, nonce: createProjectModalVisible.nonce + 1 });
        };
        return React.createElement(React.Fragment, null,
            React.createElement(antd_1.PageHeader, { title: "Projects" }),
            React.createElement(PageContent_1.default, null,
                React.createElement(antd_1.Empty, { description: "You don't have any projects yet.", image: null },
                    React.createElement(ProjectModalComponent_1.ProjectModalComponent, { key: createProjectModalVisible.nonce, visible: createProjectModalVisible.visible, onDestroy: onCreateProjectModalDestroy, ctx: "homePage" }),
                    React.createElement(antd_1.Button, { type: "primary", size: "large", onClick: onClickCreateProject }, "Create Project"))));
    }
    return React.createElement(PageLoaderComponent_1.default, null);
};
exports.HomePage = HomePage;
